import React from 'react'
const ContactPage = () => (
    <div className="section">
      <div className="columns is-centered">
        <div className="column is-two-thirds is-half-desktop">
        <p>Thanks so much for stopping by. Fill in the form below for any inquiries regarding sales, commissions, or more information about any of the artwork.</p>
    <form name="contact" method="POST" data-netlify="true" action="/">
    <input type="hidden" name="form-name" value="contact" />
    <div className="field">
    <label className="label" htmlFor="name">Name</label>
    <div className="control">
      <input className="input" type="text" name="name" placeholder="Your Name" />
    </div>
  </div>
  
  <div className="field">
    <label className="label" htmlFor="email">Email</label>
    <div className="control">
      <input className="input" type="email" name="email" placeholder="Email input" />
      </div>
  </div>
  
  <div className="field">
  <label className="label" htmlFor="subject">Subject</label>
    <div className="control">
      <input className="input" type="text" name="subject" placeholder="Text input" />
    </div>
  </div>
  
  <div className="field">
    <label className="label" htmlFor="message">Message</label>
    <div className="control">
      <textarea className="textarea" name="message" placeholder="Textarea"></textarea>
    </div>
  </div>
  <div className="field is-grouped">
    <div className="control">
      <button className="button">Submit</button>
    </div>
  </div>
  </form>
        </div>
    </div>
    </div>
)

export default ContactPage



// WEBPACK FOOTER //
// ./src/pages/contact.js